// Conteúdo por omissão da EKKO (vem da landing aprovada). O painel mostra-o a cinzento nos campos
// vazios e o site usa-o quando o campo não está preenchido.
export const EKKO_DEFAULTS = {
  brand_tagline: "Fitness & Wellbeing Center",

  hero_badge: "Maia",
  hero_title: "Mais do que treino — um eco de bem-estar no teu corpo.",
  hero_subtitle:
    "No EKKO reunimos treino, fisioterapia e nutrição num só espaço, com acompanhamento próximo e o tempo que o teu corpo precisa. Vem conhecer-nos com uma aula experimental gratuita.",
  hero_button_primary: "Marcar aula experimental",
  hero_button_secondary: "Falar connosco",
  hero_background_image:
    "https://images.unsplash.com/photo-1591258370814-01609b341790?auto=format&fit=crop&w=1200&q=80",
  hero_image_alt: "Duas pessoas a treinar no chão de um estúdio luminoso, com paredes brancas e halteres ao lado.",

  values_items: ["Experiência premium", "Comunidade", "Bem-estar", "Serenidade"],

  pillars_eyebrow: "Os três pilares",
  pillars_title: "Treino, fisioterapia e nutrição a trabalhar juntos",
  pillars_subtitle: "Um acompanhamento pensado como um todo, para que o progresso seja sustentável e o corpo acompanhe.",
  pillars: [
    {
      title: "Treino",
      text: "Planos adaptados ao teu ritmo e ao teu momento, com acompanhamento técnico dentro do espaço.",
      tags: "Musculação, Cardio, Aulas de grupo, Personal training",
    },
    {
      title: "Fisioterapia",
      text: "Recuperação, alívio de dores e trabalho de mobilidade, para treinares com confiança e sem receios.",
      tags: "Recuperação, Mobilidade, Prevenção",
    },
    {
      title: "Nutrição",
      text: "Hábitos alimentares que se sustentam no dia a dia e dão suporte real ao trabalho feito no treino.",
      tags: "Avaliação, Plano alimentar, Acompanhamento",
    },
  ],

  schedule_eyebrow: "Horários",
  schedule_title: "Encontra o teu <span style=\"color: #A6C48A\">momento</span>",
  schedule_subtitle: "Aulas ao longo do dia e espaço livre para treinares ao teu ritmo.",
  schedule_label_classes: "Aulas",
  schedule_label_open: "Treino livre",

  coaches_eyebrow: "A equipa",
  coaches_title: "Quem te <span style=\"color: #A6C48A\">acompanha</span>",
  coaches_subtitle: "Profissionais de treino, fisioterapia e nutrição que trabalham juntos no teu progresso.",

  pricing_eyebrow: "Preços",
  pricing_title: "Planos e <span style=\"color: #A6C48A\">serviços</span>",
  pricing_subtitle: "Escolhe o acompanhamento que faz sentido para ti. Na dúvida, fala connosco.",

  testimonials_eyebrow: "Testemunhos",
  testimonials_title: "Quem treina connosco",
  testimonials_subtitle: "",

  faq_eyebrow: "Perguntas frequentes",
  faq_title: "Antes da primeira visita",
  faq_subtitle: "",

  gallery_eyebrow: "O espaço",
  gallery_title: "Um ambiente calmo, luminoso e familiar",
  gallery_subtitle: "Luz natural, tons neutros e espaço para treinar sem pressa. Conhece o EKKO antes de decidires.",
  gallery_images: [
    {
      image: "https://images.unsplash.com/photo-1552196563-55cd4e45efb3?auto=format&fit=crop&w=900&q=80",
      alt: "Pessoa sentada em posição de meditação sobre um tapete, num espaço de chão de madeira e parede branca.",
    },
    {
      image: "https://images.unsplash.com/photo-1518310383802-640c2de311b2?auto=format&fit=crop&w=900&q=80",
      alt: "Aula de grupo com halteres num estúdio amplo com grandes janelas e luz natural.",
    },
    {
      image: "https://images.unsplash.com/photo-1594737625785-a6cbdabd333c?auto=format&fit=crop&w=900&q=80",
      alt: "Pessoa a fazer flexões apoiada em halteres, sobre chão de madeira clara junto a uma parede branca.",
    },
  ],

  instagram_eyebrow: "Instagram",
  instagram_title: "Acompanha o dia a dia do <span style=\"color: #A6C48A\">EKKO</span>",
  instagram_subtitle: "",
  instagram_handle: "@ekko.fitness.center",
  instagram_url: "https://www.instagram.com/ekko.fitness.center/",

  contact_eyebrow: "Aula experimental gratuita",
  contact_title: "Começa por <span style=\"color: #A6C48A\">experimentar</span>",
  contact_subtitle: "Envia-nos uma mensagem e combinamos contigo o melhor momento para a tua primeira visita.",
  form_title: "Marca a tua aula experimental",
  form_text: "Escreve o teu nome na mensagem e abrimos a conversa no WhatsApp. Sem compromisso.",
  form_message: "Olá! Gostava de marcar a minha aula experimental gratuita no EKKO. O meu nome é ",
  form_hint: "Acrescenta o teu nome no fim da mensagem antes de enviar.",

  whatsapp_number: "351918533844",
  contact_phone: "+351 918 533 844",
  contact_address: "Maia, Portugal",
  contact_email: "",
  facebook_url: "",

  footer_tagline: "Treino · Fisioterapia · Nutrição — na Maia.",
  footer_text: "© 2026 EKKO Fitness Center. Todos os direitos reservados.",
};

// Texto simples de um campo, com o valor por omissão quando está vazio
export function ekkoText(content, key) {
  const value = content?.[key];
  if (typeof value === "string" && value.trim() !== "") return value;
  return EKKO_DEFAULTS[key] ?? "";
}

// Listas (valores, pilares, galeria): usa a do painel só se tiver pelo menos um elemento
export function ekkoList(content, key) {
  const value = content?.[key];
  return Array.isArray(value) && value.length > 0 ? value : EKKO_DEFAULTS[key] || [];
}
